import ShiftDailyIcon from '@material-ui/icons/ViewList';

import ShiftDailyList from './ShiftDailyList';

export default {
  list: ShiftDailyList,
  icon: ShiftDailyIcon,
};
